<template>
    <div class="wai">
        <div class="wyjj">
            <div class="wyjjitem" v-for="(item,index) in list" :key="index" @click="go(item)">
                <div class="zfx">
                    <img :src="item.src" alt="">
                </div>
                <span>{{item.name}}</span>
            </div>
            <div class="wyjjitem"></div>
            <div class="wyjjitem"></div>
            <div class="wyjjitem"></div>
            <div class="wyjjitem"></div>

        </div>
    </div>
    
</template>
<script>
export default {
    data() {
        return {
            list:[
                {
                    name:'业主缴费',
                    src:require('../../assets/wyjj/gtfy.png'),
					path: "/wyfw/jflist",
                    query:'业主缴费'    
                }
            ]
        }
    },
    mounted() {
                    if(JSON.parse(localStorage.getItem('userInfo'))){
                        // debugger
                       this.list= this.list.filter((x) => x.name !== "业主缴费");
            }
    },
    methods: {
        go(item){

            this.$router.push({ path: item.path, query: {type:item.query} });
        }
    },
}
</script>
<style lang="less" scoped>
.wai{
    display: flex;
    justify-content: center;
}
    .wyjj{
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        .wyjjitem{
            height: 120px;
            width: 100px;
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;
            .zfx{
                height: 70px;
                width: 70px;
                background-color: #00b5ff;
                border-radius: 10px;
                display: flex;
                align-items: center;
                justify-content: center;
                img{
                    height: 50px;
                    width: 50px;
                }
            }
            span{
                margin-top: 5px;
            }
        }
    }
</style>